import React from 'react';
import PropTypes from 'prop-types';
import Button from 'base-ui/dist/Button';
import Icon from 'base-ui/dist/Icon';
import { intl } from 'components/LocaleProvider';
import MostSearchedItem from './MostSearchedItem';

import messages from './messages';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const MostSearched = ({ widget }) => {
  const handleCreatePlaceholder = (pageType) => {
    const {
      labelSearchHealth,
      labelSearchPets,
      labelSearchTravel,
      labelSearchFitness,
      labelSearchAuto,
      labelSearchGeneric,
    } = messages;
    switch (pageType) {
      case 'health':
      case 'psychology':
      case 'family':
        return labelSearchHealth;
      case 'animals':
        return labelSearchPets;
      case 'travel':
        return labelSearchTravel;
      case 'fitness':
        return labelSearchFitness;
      case 'auto':
        return labelSearchAuto;
      case 'others':
      case 'decor':
      default:
        return labelSearchGeneric;
    }
  };

  const pageType = publicRuntimeConfig.analytics_datasource;

  return (
    <section id="most-searched-widget" className="widget">
      <div className="section-title main-border">
        <span className="label text-uppercase">{widget.options.title}</span>
      </div>
      <div>
        <form className="search-form display-block position-relative" action={`${publicRuntimeConfig.PUBLIC_URL}/`} method="get" target="_top">
          <label htmlFor="most-searched-input" className="display-none">
            {intl.formatMessage(handleCreatePlaceholder(pageType))}
          </label>
          <input id="most-searched-input" type="text" className="full input border-grey" placeholder={intl.formatMessage(handleCreatePlaceholder(pageType))} name="s" />
          <Button
            className="btn transparent-bg transparent-border text-color"
            type="submit"
            color="white"
            textColor="main"
            borderColor="white"
            tag="button"
            data-with-google-events="true"
            data-google-events={JSON.stringify({
              data: {
                action: 'click',
                category: 'Search',
                label: 'Search'
              }
            })}
          >
            <Icon name="search" prefix="fas" />
          </Button>
        </form>
        <div className="tag-cloud">
          {widget.content.map((item) => (
            <MostSearchedItem key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
};

MostSearched.defaultProps = {
  widget: {
    options: {},
    content: [],
  },
};

MostSearched.propTypes = {
  widget: PropTypes.object,
};

export default MostSearched;
